import React, { useContext } from 'react';
import { IconProps } from '../iconProps';
import { UiContext } from 'shared/lib/contexts/uiContext';
import cx from 'classnames';
import { defaultSpacingPresets } from 'shared/hooks/useGetSpacing';

export default function IconAI({
  isAutoscallable = true,
  sizeKey = '22x22',
  onClick,
  style,
}: IconProps) {
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      className={cx('icon', { 'icon-disabled': !onClick })}
      onClick={onClick}
      style={style}
      width={w}
      height={h}
      viewBox="0 0 23 22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3685_63582)">
        <path
          d="M22.4915 0.0302734H0.552734V21.9692H22.4915V0.0302734Z"
          fill="#F0A024"
        />
        <path
          d="M21.5258 0.996094H1.51758V21.0043H21.5258V0.996094Z"
          fill="#373122"
        />
        <path
          d="M8.13931 12.5189L7.34735 15.1451C7.33433 15.2357 7.29536 15.2659 7.21754 15.2659H5.89325C5.80245 15.2659 5.77663 15.2205 5.80245 15.1151C6.50358 12.8056 7.68487 8.95675 8.51567 6.3455C8.55469 6.19463 8.59366 6.04364 8.61953 5.51534C8.61953 5.45505 8.65854 5.4248 8.69752 5.4248H10.4891C10.5539 5.4248 10.567 5.43993 10.593 5.50026C11.5535 8.59448 12.6051 12.0057 13.5917 15.1301C13.6177 15.2205 13.5917 15.2659 13.5138 15.2659H12.0597C11.9948 15.2659 11.9689 15.2357 11.943 15.1754L11.1121 12.5189H8.13931V12.5189ZM10.7616 11.0396C10.5019 10.0283 9.86575 7.99068 9.60626 6.93412H9.59324C9.39838 7.93027 8.8663 9.63587 8.47679 11.0396H10.7616Z"
          fill="#F0A024"
        />
        <path
          d="M14.9082 5.99526C14.9082 5.43684 15.278 5.05957 15.7754 5.05957C16.2985 5.05957 16.6174 5.43684 16.6174 5.99526C16.6174 6.56889 16.273 6.93112 15.7628 6.93112C15.2525 6.93112 14.9082 6.56889 14.9082 5.99526ZM14.9974 8.048C14.9974 7.95747 15.0228 7.92735 15.0868 7.92735H16.4387C16.5153 7.92735 16.5409 7.94243 16.5409 8.048V15.1421C16.5409 15.2177 16.5153 15.2627 16.4387 15.2627H15.1122C15.0357 15.2627 14.9974 15.2327 14.9974 15.1271V8.048Z"
          fill="#F0A024"
        />
      </g>
      <defs>
        <clipPath id="clip0_3685_63582">
          <rect
            width="22"
            height="22"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
